<template>
    <div class="white-space-nowrap">
        <span class="text">{{ row[column.key] }}%</span>
        <span v-if="column.key == 'service_rate' && row.cos_type == 1 && row['ad_service_ratio'] != undefined"><span style="color: #999;margin: 0 4px;">|</span>投放期{{ row['ad_service_ratio'] }}%</span>
        <span class="text" v-if="row['colonel_type'] === '1' && column['showPay']">{{ '(支出' + row['disburse_commission_rate'] + '%)' }}</span>
    </div>
</template>

<script>
import mixin from "@/components/tableCells/mixin";

export default {
    name: "serviceRateCell",
    mixins: [mixin]
}
</script>

<style scoped>
.text {
    overflow: hidden;
    text-overflow:ellipsis;
    display: inline-flex;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}
.white-space-nowrap {
  white-space: nowrap;
}
</style>
